import { Component, OnInit } from "@angular/core";
import { BaseDatasourceComponent } from "../base-datasource/base-datasource.component";
import { CommonService, Currency, CurrencyService, TIMEZONES, UserService } from "@rubii/frontend-common";
import { ConfigService } from "src/app/services/config.service";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DatasourceConnectionComponent } from "../../datasource-connection/datasource-connection.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ClientService } from "../../../services/client.service";

@Component({
    selector: 'app-rokt',
    styleUrls: ['./rokt.component.scss'],
    templateUrl: './rokt.component.html'
})
export class RoktComponent extends BaseDatasourceComponent implements OnInit {

    constructor(private client: ClientService,
        private config: ConfigService,
        private snackBar: MatSnackBar,
        private dialogRef: MatDialogRef<DatasourceConnectionComponent>,
        private currencySvc: CurrencyService,) {
        super();
    }

    async ngOnInit() {
        this.connectionForm = new FormGroup({
            accountId: new FormControl('', [Validators.required]),
            appId: new FormControl('', [Validators.required]),
            appSecret: new FormControl('', [Validators.required]),
        });
    }

    connect() {
        if (!this.connectionForm.valid) {
            this.openSnackBarWarning(this.snackBar, 'Please fill all required fields.', 'closed');
            return;
        }
        this.client.account.saveRoktConfig(this.connectionForm.value).then(result => {
            this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
              this.dialogRef.close();
          }).catch(e => this.openSnackBarWarning(this.snackBar, e.message, 'closed'));
        
    }

}